export default __webpack_public_path__ + "static/active_earth-315afec62fe19300d14143221a44447e.jpg";